import { Box, Button } from '@mui/material';
import React from 'react';

const AddButton = ({ text, icon, sx, handleClick }) => {
  return (
    <Box>
      <Button variant='standard' startIcon={icon} sx={sx} onClick={handleClick}>
        {text}
      </Button>
    </Box>
  );
};

export default AddButton;
